import React from "react";
import { Button, Container, Row, Col } from "reactstrap";

function CardPagine() {
  return (
    <>
      <div className="section section-dark">
        {/* Inizio del container */}
        <Container>

            <h2 className="title text-center">Argomenti</h2>

            {/* Inizio della 1° riga */}
            <Row className="example-page">
                
                {/* Inizio 1° Card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/RiceverePaginaHtml" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/ricevere_pagina_html.jpg")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/RiceverePaginaHtml"
                        target="_blank"
                    >
                        Ricevere pagina HTML
                    </Button>
                </Col>
                {/* Fine 1° Card */}

                {/* Inizio 2° card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/Dispatcher" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/dispatcher.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/Dispatcher"
                        target="_blank"
                    >
                        Dispatcher
                    </Button>
                </Col>
                {/* Fine 2° card */}

            </Row>
            {/* Fine della 1° riga */}

            {/* Inizio della 2° riga */}
            <Row className="example-page">
                
                {/* Inizio 3° Card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/CommonJS" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/common_js.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/CommonJS"
                        target="_blank"
                    >
                        Common JS
                    </Button>
                </Col>
                {/* Fine 3° Card */}

                {/* Inizio 4° card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/EsModule" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/es_module.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/EsModule"
                        target="_blank"
                    >
                        Es module
                    </Button>
                </Col>
                {/* Fine 4° card */}

            </Row>
            {/* Fine della 2° riga */}

            {/* Inizio della 3° riga */}
            <Row className="example-page">
                
                {/* Inizio 5° Card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/AsyncAwait" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/async_e_await.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/AsyncAwait"
                        target="_blank"
                    >
                        Async e Await
                    </Button>
                </Col>
                {/* Fine 5° Card */}

                {/* Inizio 6° card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="/Express" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/express.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/Express"
                        target="_blank"
                    >
                        Express
                    </Button>
                </Col>
                {/* Fine 6° card */}

            </Row>
            {/* Fine della 3° riga */}

            {/* Inizio della 4° riga */}
            <Row className="example-page">
                
                {/* Inizio 7° Card */}
                <Col className="text-center mx-auto" md="6">
                    {/* Immagine */}
                    <a href="/TemplateEngine" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/CardPagine/template_engine.png")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="/TemplateEngine"
                        target="_blank"
                    >
                        Template Engine
                    </Button>
                </Col>
                {/* Fine 7° Card */}

            </Row>
            {/* Fine della 4° riga */}

        </Container>
        {/* Fine del container */}
      </div>
    </>
  );
}

export default CardPagine;
